import { useState, useEffect } from "react";
import { useUserContext } from "../../../contexts/ProviderProvider";
import useNotification from "../../../hooks/useNotification";
import {
    runAllFrontAssetGeneration, getRunnableFrontAssets, stopFrontAssetGeneration
} from "../../../API/equipmentManager";
import {
    Button,
    Divider,
    Box,
    CircularProgress
} from "@mui/material";
import TaskUpdateView from "./TaskUpdateView";
import SchoolSportFilter from "../../common/SchoolSportFilter";
import RunnableDataView from "./RunnableDataView";
import StopIcon from '@mui/icons-material/Stop';
import AreYouSure from "../../common/AreYouSure";

const FrontAssetGeneration = ({ loading, setLoading, data }) => {
    const user = useUserContext();
    const notify = useNotification();
    const [activeTab, setActiveTab] = useState("Running");
    const [selectedSchool, setSelectedSchool] = useState("");
    const [selectedSport, setSelectedSport] = useState("");
    const [universityCount, setUniversityCount] = useState({});
    const [expanded, setExpanded] = useState(false);
    const [runnableAssetData, setRunnableAssetData] = useState([]);
    const [selectedAssetData, setSelectedAssetdata] = useState([]);
    const [tableColumns, setTableColumns] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [assetsCount, setAssetsCount] = useState(0);

    // isModalOpen, areYouSureMessage, areYouSureClose, areYouSureSubmit

    const setUniversities = (data) => {
        let universityCount = {}
        data.forEach(asset => {
            if (asset.university in universityCount) {
                universityCount[asset.university][0] += 1
            }
            else {
                universityCount[asset.university] = [0, 0]
            }
        })
        setUniversityCount(universityCount)
    }

    const changeSelectedData = (data, school, sport) => {

        let selectedData = []
        if (school === "" && sport === "") {
            selectedData = data
        }
        else {
            selectedData = data.filter(asset => {
                if (school === "") {
                    return asset.sport === sport
                } else if (sport === "") {
                    return asset.university === school
                }
                return (asset.university === school && asset.sport === sport)
            })
        }
        setSelectedAssetdata(selectedData)

    }

    const changeUniversity = (university) => {
        const temp_university = university == null || university == undefined ? "" : university
        setSelectedSchool(temp_university)
        changeSelectedData(runnableAssetData, temp_university, selectedSport)
    }

    const changeSport = (sport) => {
        const temp_sport = sport == null || sport == undefined ? "" : sport
        setSelectedSport(temp_sport)
        changeSelectedData(runnableAssetData, selectedSchool, temp_sport)
    }
    useEffect(() => {
        const getAlerts = () => {
            getRunnableFrontAssets(user).then(res => {
                const { assets, assetsCount: assetsCountResponse } = res.data.obj
                setRunnableAssetData(assets);
                setUniversities(assets)
                changeSelectedData(assets, selectedSchool, selectedSport)
                setAssetsCount(assetsCountResponse);
                setIsLoading(false);
                if (assets.length > 0) {
                    setTableColumns(Object.keys(assets[0]))
                }
            }).catch((e) => {
                console.log(e);
                notify("Failed to get Status of EquipmentManager");
            });
        }
        getAlerts()
        const interval = setInterval(() => getAlerts(), 100000)
        return () => {
            clearInterval(interval);
        }
    }, [])


    const runAll = () => {
        const university = selectedSchool === undefined || selectedSchool === null ? "" : selectedSchool
        const sport = selectedSport === undefined || selectedSport === null ? "" : selectedSport
        const payload = { "University": university, "Sport": sport }
        runAllFrontAssetGeneration(payload, user).then(() => {
            notify({ msg: "Successfully Started Execution", variant: "success" })
        }).catch(() => {
            notify({ msg: "Failed to run all asset generation", variant: "error" })
        })
    }

    const stopAssets = () => {
        stopFrontAssetGeneration(user).then(() => {
            setIsLoading(true);
            getRunnableFrontAssets(user).then(res => {
                const { assets, assetsCount: assetsCountResponse } = res.data.obj
                setRunnableAssetData(assets);
                setUniversities(assets)
                changeSelectedData(assets, selectedSchool, selectedSport)
                setAssetsCount(assetsCountResponse);
                setIsLoading(false);
                if (assets.length > 0) {
                    setTableColumns(Object.keys(assets[0]))
                }
            }).catch((e) => {
                console.log(e);
                notify("Failed to get Status of EquipmentManager");
            });
            notify({ msg: "Successfully STOPPED Aseet Generation Execution", variant: "success" })
        }).catch(() => {
            notify({ msg: "Failed to stop asset generation", variant: "error" })
        })
    }

    return (
        <div
            style={{
                width: "100%",
                height: "100vh",
            }}
        >
            <Divider variant="fullWidth" />

            <div style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                marginBottom: "20px"
            }}>
                <Button variant="outlined" color="error" onClick={(() => setIsModalOpen(true))} sx={{ margin: "10px" }}><StopIcon />Stop Slammin'</Button>
            </div>

            <div style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                marginBottom: "20px"
            }}>
                Assets Count: {!isLoading ? assetsCount : <CircularProgress size="20px" style={{ margin: '0 10px' }} />}
            </div>

            <div style={{
                paddingLeft: "10%",
                width: "90%",
            }}>
                <SchoolSportFilter
                    selectedSchool={selectedSchool}
                    setSelectedSchool={changeUniversity}
                    selectedSport={selectedSport}
                    setSelectedSport={changeSport}
                    universitiesCount={universityCount}
                    hideCount={true}
                />
                <RunnableDataView expanded={expanded} setExpanded={setExpanded} title={"Runnable Assets"} tableData={selectedAssetData} tableColumns={tableColumns} tableOptions={{}} />
            </div>

            <div style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
            }}>


                <Button sx={{ width: "70%", height: "20px", padding: "20px", marginRight: "15%", marginLeft: "15%", marginTop: "30px" }} variant={"contained"} onClick={runAll}>
                    Run All Front Asset Generation
                </Button>


            </div>
            <Divider style={{ margin: "20px" }} />
            <TaskUpdateView activeTab={activeTab} setTab={setActiveTab} loading={loading} setAssetLoading={setLoading} data={data} taskType="FrontAsset" />
            <AreYouSure
                style={{
                    backgroundColor: "background.default",
                    margin: "auto",
                    marginTop: "10vh",
                    padding: "20px",
                    width: "30vw",
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    borderRadius: "5px",
                }}
                open={isModalOpen}
                message={"Do you want to Stop Asset Generation"}
                handleClose={() => setIsModalOpen(false)}
                yes={() => {
                    stopAssets();
                    setIsModalOpen(false);
                }}
                no={() => setIsModalOpen(false)}
            />
        </div >
    )
}
export default FrontAssetGeneration;